module.exports = __webpack_public_path__ + "chat-bg.b04e814510747fb82cb1";


//////////////////
// WEBPACK FOOTER
// D:/Projects/Empower360Plus/EmpowerWeb2.0/A4.Empower/A4.Empower/ClientApp/src/assets/images/chat-bg.jpg
// module id = ../../../../../src/assets/images/chat-bg.jpg
// module chunks = styles